// src/services/HistoryRelanceService.js
import api from "@/api/axiosApi";
import handleHttpError from "@/util/HttpErrorHandler";

const API_URL = `/history-relance`;

export const saveHistoryRelance = async (historyRelance) => {
  try {
    const response = await api.post(API_URL, historyRelance);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'enregistrement d'une relance :", error);
    handleHttpError(error, "Échec de l'enregistrement de la relance.");
    throw error;
  }
};

export const getAllHistoryRelances = async () => {
  try {
    const response = await api.get(API_URL);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des relances :", error);
    handleHttpError(error, "Impossible de récupérer les relances.");
    throw error;
  }
};

export const getHistoryRelanceById = async (id) => {
  try {
    const response = await api.get(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération de la relance :", error);
    handleHttpError(error, "Impossible de récupérer la relance.");
    throw error;
  }
};

export const deleteHistoryRelance = async (id) => {
  try {
    await api.delete(`${API_URL}/${id}`);
  } catch (error) {
    console.error("Erreur lors de la suppression de la relance :", error);
    handleHttpError(error, "Échec de la suppression de la relance.");
    throw error;
  }
};

export const getHistoryRelancesByYear = async (year) => {
  try {
    const response = await api.get(`${API_URL}/year/${year}`);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des relances par année :", error);
    handleHttpError(error, "Impossible de récupérer les relances pour cette année.");
    throw error;
  }
};

export const getHistoryRelancesByUserAndYear = async (userId, year) => {
  try {
    const response = await api.get(`${API_URL}/user/${userId}/year/${year}`);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des relances pour l'utilisateur :", error);
    handleHttpError(error, "Impossible de récupérer les relances pour cet utilisateur.");
    throw error;
  }
};

export const getHistoryRelancesByUserTypeYear = async (userId, typeRelance, year) => {
  try {
    const response = await api.get(`${API_URL}/user/${userId}/type/${typeRelance}/year/${year}`);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des relances ciblées :", error);
    handleHttpError(error, "Impossible de récupérer les relances ciblées.");
    throw error;
  }
};
